module.exports = __webpack_public_path__ + "04fb869d4181078e0a7322a33881f72b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/github-logo.png
// module id = 257
// module chunks = 1